// extracted by mini-css-extract-plugin
export default {"container":"BuyDataDropDown_container__oGMiw"};